import baliBeach from './images/bali-beach.svg';
import nzMountains from './images/nz-mountains.svg';

const data = [
  {
    cta: {
      name: 'Find out more about Bali Travel Insurance',
      url: '/travel-insurance/bali',
    },
    description:
      'Bali is one of the most beloved destinations for Aussie travellers. ahm has a range of travel insurance cover options to suit your Bali getaway.',
    imageObject: {
      caption: 'Bali beach',
      image: {
        asset: {
          _id: 'bali-image',
          url: baliBeach.src,
        },
      },
    },
    title: 'Bali',
  },
  {
    cta: {
      name: 'Find out more about New Zealand Travel Insurance',
      url: '/travel-insurance/new-zealand',
    },
    description:
      'Whether you’re planning a summer getaway or a winter break, ahm has travel insurance for your New Zealand trip.',
    imageObject: {
      caption: 'New Zealand mountains',
      image: {
        asset: {
          _id: 'nz-image',
          url: nzMountains.src,
        },
      },
    },
    title: 'New Zealand',
  },
];

export default data;
